import { useEffect, useState } from "react";
import api from "../lib/api";
import ProductCard from "../components/ProductCard";

const HERO_IMAGE =
  "https://images.unsplash.com/photo-1584028377143-21f876eb9c1e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxjbGVhbiUyMGdsYXNzJTIwdmlhbCUyMHByb2R1Y3R8ZW58MHx8fHwxNzgxNDI4NTUxfDA&ixlib=rb-4.1.0&q=85";

export default function Home() {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    api.get("/products").then((r) => setProducts(r.data));
  }, []);

  return (
    <div data-testid="home-page">
      {/* HERO — compact */}
      <section className="relative min-h-[60vh] flex items-end overflow-hidden">
        <img
          src={HERO_IMAGE}
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-secondary/75 via-secondary/30 to-transparent" />
        <div className="relative z-10 px-6 md:px-12 lg:px-24 pb-14 md:pb-20 max-w-5xl">
          <p className="overline text-background/80 mb-5" data-testid="hero-eyebrow">
            Research-grade peptides
          </p>
          <h1 className="editorial-heading text-5xl sm:text-6xl md:text-7xl text-background leading-[0.95]">
            The science of <em className="italic text-primary">restoration</em>,
            <br />
            quietly perfected.
          </h1>
        </div>
      </section>

      {/* PRODUCTS — the whole catalog */}
      <section
        className="px-6 md:px-12 lg:px-24 py-16 md:py-20"
        data-testid="home-products-section"
      >
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-12 gap-4">
          <div>
            <p className="overline text-primary mb-3">The catalog</p>
            <h2 className="editorial-heading text-3xl md:text-4xl text-secondary">
              {products.length > 0
                ? `${products.length} research peptides`
                : "Loading catalog…"}
            </h2>
          </div>
          <p className="text-sm text-muted-foreground max-w-sm leading-relaxed">
            Every vial assayed for purity and identity. For laboratory and research use only.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-12">
          {products.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      </section>
    </div>
  );
}
